export const EditingSpaceModel = Symbol('EditingSpaceModel');
